import { render, staticRenderFns } from "./LiveConference.vue?vue&type=template&id=4dac74bf&scoped=true&"
import script from "./LiveConference.vue?vue&type=script&lang=js&"
export * from "./LiveConference.vue?vue&type=script&lang=js&"
import style0 from "./LiveConference.vue?vue&type=style&index=0&id=4dac74bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac74bf",
  null
  
)

export default component.exports